import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output} from "@angular/core";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {FormBuilder, FormControl} from "@angular/forms";
import {DepotService} from "../../services/depot-service/depot.service";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {appInjector} from "../../../index";
import {ApolloQueryObservable} from "apollo-angular";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";
import {filter} from "rxjs/operators";

@Component({
  selector: 'vb-depot-selection',
  templateUrl: './depot-selection.component.html',
  styleUrls: ['./depot-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => DepotSelectionComponent)}]
})
export class DepotSelectionComponent extends AbstractVisbosControl<Depot, FormControl> implements OnInit {

  private _selectedDepotCuid: string;

  get selectedDepotCuid(): string {
    return this._selectedDepotCuid;
  }

  @Input()
  set selectedDepotCuid(value: string) {
    this._selectedDepotCuid = value;
    if (this.depotList && this.control) {
      this.item = this.depotList.find(dl => dl.cuid == this.selectedDepotCuid);
      this.control.setValue(this.item ? this.item.cuid : undefined);
    }
  }

  private _adminUnitCuid$: Observable<string>;

  @Input('adminUnitCuid')
  set adminUnitCuid$(value: Observable<string>) {
    this._adminUnitCuid$ = value;
  }

  get adminUnitCuid$(): Observable<string> {
    if (this._adminUnitCuid$) {
      return this._adminUnitCuid$;
    } else {
      return this.activeAdminUnitCuid$;
    }
  }

  @Output()
  depotSelected: EventEmitter<Depot> = new EventEmitter<Depot>();

  @Output()
  depotChanged: EventEmitter<Depot> = new EventEmitter<Depot>();

  @Output()
  depotUnSelected: EventEmitter<any> = new EventEmitter();

  private depotList$: ApolloQueryObservable<Depot[]>;
  private depotListSub: Subscription;
  depotList: Depot[] = [];

  constructor(fb: FormBuilder, cd: ChangeDetectorRef,
              private depotService: DepotService) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();

    this.depotList$ = this.depotService.getDepotsList(this.adminUnitCuid$);
    this.depotListSub = this.depotList$.subscribe((depots: any) => {
      this.depotList = depots;
      if (this.selectedDepotCuid) {
        this.item = this.depotList.find(dl => dl.cuid == this.selectedDepotCuid);
        this.control.setValue(this.item ? this.item.cuid : undefined);
      }
    });

  }

  ngOnDestroy(): void {
    this.depotListSub.unsubscribe();
  }

  buildControlContent(values?: Depot): FormControl {
    return DepotSelectionComponent.initControl(this.fb, values);
  }

  public static initControl(fb: FormBuilder = null, value?: Depot): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  onDepotSelected(depot: Depot) {
    this.depotSelected.emit(depot);
  }

  onDepotChanged(depot: Depot) {
    this.depotChanged.emit(depot);
  }

  onDepotUnselected() {
    this.depotUnSelected.emit();
  }

  public setDefaultValues(item?: Depot): { [controlKey: string]: any } | any {
    return this.setValue(item, 'cuid');
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/depot/depot-selection/depot-selection.component.ts